import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { BaseCtrlValueAccessorFormArrayComponent, FormManagerService } from '@sim/form';
import { ClassName } from '@sim/role';

import { AUT, AUTMeta } from '@atmi/core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-aut-form',
  styleUrls: ['./aut-form.component.scss'],
  templateUrl: './aut-form.component.html',
})
export class AutFormComponent extends BaseCtrlValueAccessorFormArrayComponent<AUT> implements OnDestroy, OnInit {

  @Input() classNames: ClassName[] = [];

  constructor(
    private readonly formManager: FormManagerService,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addAUTHandler() {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage AUT without a control');
    }

    const autToAdd = this.form.length ? { AUTA: '', AUTN: '' } : { AUTN: 'Igor Mitoraj', AUTA: 'Oederan, 26 marzo 1944 – Parigi, 6 ottobre 2014' };

    const AUTControl = this.formManager.makeForm(AUTMeta, autToAdd);
    this.form.push(AUTControl);
  }

  removeAUTHandler(index: number) {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage AUT without a control');
    }

    this.form.removeAt(index);
  }
}
